import { get, post } from '@/services/axios'

class onlineData {
    // 线上用户-list
    getUserList(params: any) {
        
        return post('/TsManageApi/getUserList',params)
    }  
    //同步数据
    tsManageSync() {
        
        return post('/NormalizedApi/tsManageSync',{})
    } 
    //添加老师
    addSigleTeacher(params: any) {
        return post('/TsManageApi/addSigleTeacher',params)
    }  
    //添加学生
    addSigleStudent(params: any) {
        return post('/TsManageApi/addSigleStudent',params)
    } 

    //添加老师,通过账号模式
    addSigleTeacherByAccount(params: any) {
        return post('/TsManageApi/addSigleTeacherByAccount',params)
    }  
    //添加学生,通过账号模式
    addSigleStudentByAccount(params: any) {
        return post('/TsManageApi/addSigleStudentByAccount',params)
    } 

    //标记为已认证
    setUserAttestation(params: any) {
        
        return post('/TsManageApi/setUserAttestation',params)
    } 
    //取消标记为已认证
    dismissUserAgency(params: any) {
        
        return post('/TsManageApi/dismissUserAgency',params)
    } 
    //线上课堂-list
    classStatisticsPage(params: any) {
        
        return post('/ClassApi/classStatisticsPage',params)
    } 
    //线上课堂-list -删除
    userDelete(params: any) {
        
        return post('/TsManageApi/userDelete',params)
    } 

    // 学生评教 start
    //学生教评-list
    getLists(params: any) {
        
        return post('/EvaluationTeacherApi/getLists',params)
    }
    //停止评教
    stopEvaluation(params: any) {
        
        return post('/EvaluationTeacherApi/stopEvaluation',params)
    }
    //发布评教
    startEvaluation(params: any) {
        
        return post('/EvaluationTeacherApi/startEvaluation',params)
    }
    //创建评教
    createEvaluationTeacher(params: any) {
        
        return post('/EvaluationTeacherApi/createEvaluationTeacher',params)
    }
     //delete评教
     delEvaluation(params: any) {
        
        return post('/EvaluationTeacherApi/delEvaluation',params)
    }
    //创建评教-list
    getTemplateLists() {
        
        return post('/EvaluationTeacherApi/getTemplateLists',{})
    }
    //获取编辑详情
    getSubjectList(params: any) {
        
        return post('/EvaluationTeacherApi/getSubjectList',params)
    }
    //编辑详情
    updateEvalTeacherData(params: any) {
        
        return post('/EvaluationTeacherApi/updateEvalTeacherData',params)
    }
    //添加试题
    addDigitMark(params: any) {
        
        return post('/EvaluationTeacherApi/addDigitMark',params)
    }
    //编辑试题
    editDigitMark(params: any) {
        
        return post('/EvaluationTeacherApi/editDigitMark',params)
    }
    //delete试题
    delSubjectBat(params: any) {
        
        return post('/EvaluationTeacherApi/delSubjectBat',params)
    }
    //试题排序
    updateSortBat(params: any) {
        
        return post('/EvaluationTeacherApi/updateSortBat',params)
    }
    //保存为模板
    saveAsTemplate(params: any) {
        
        return post('/EvaluationTeacherApi/saveAsTemplate',params)
    }
    //评教结果
    getEvalResult(params: any) {
        
        return post('/EvaluationTeacherApi/getEvalResult',params)
    }
    //答卷数据
    getCourseEvalResult(params: any) {
        
        return post('/EvaluationTeacherApi/getCourseEvalResult',params)
    }
    //统计详情
    getTeacherEvalResult(params: any) {
        
        return post('/EvaluationTeacherApi/getTeacherEvalResult',params)
    }
    //统计数据
    getCourseEvalResultHandupLists(params: any) {
        
        return post('/EvaluationTeacherApi/getCourseEvalResultHandupLists',params)
    }
    // 学生评教 end
    //资源管理 strat
    //获取校区列表
    getCampusLists() {
        
        return post('/Classmonitoring/CampusApi/getCampusLists',{})
    }
    //新增校区
    addCampus(params: any) {
        
        return post('/Classmonitoring/CampusApi/addCampus',params)
    }
    //删除某个校区
    deleteCampus(params: any) {
        
        return post('/Classmonitoring/CampusApi/deleteCampus',params)
    }
    //更新校区
    updateCampus(params: any) {
        
        return post('/Classmonitoring/CampusApi/updateCampus',params)
    }
    //获取楼宇列表
    getBuildingLists(params: any) {
        
        return post('/Classmonitoring/BuildingApi/getBuildingLists',params)
    }
    //添加楼宇
    addBuilding(params: any) {
        
        return post('/Classmonitoring/BuildingApi/addBuilding',params)
    }
    //更新楼宇
    updateBuilding(params: any) {
        
        return post('/Classmonitoring/BuildingApi/updateBuilding',params)
    }
     //更新楼宇
     deleteBuilding(params: any) {
        
        return post('/Classmonitoring/BuildingApi/deleteBuilding',params)
    }
    //获取教室的列表
    getClassRoomLists(params: any) {
        
        return post('/Classmonitoring/ClassroomApi/getClassRoomLists',params)
    }
    //添加教室
    addClassroom(params: any) {
        
        return post('/Classmonitoring/ClassroomApi/addClassroom',params)
    }
    //更新教室
    updateClassroom(params: any) {
        
        return post('/Classmonitoring/ClassroomApi/updateClassroom',params)
    }
    //删除某个教室
    deleteClassroom(params: any) {
        
        return post('/Classmonitoring/ClassroomApi/deleteClassroom',params)
    }
    //资源管理 end

}

const onlineDataApi = new onlineData()
export default onlineDataApi
